import React from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import Navbar from '../components/navbar'
import Footer from '../components/footer'
import './legal.css'

const Impressum = () => {
  return (
    <div className="legal-container">
      <Helmet>
        <title>Impressum | Social Media Recruiting Agentur</title>
        <meta name="description" content="Impressum der Social Media Recruiting Agentur - track by track GmbH. Kontaktdaten, Handelsregister und rechtliche Informationen." />
        <meta property="og:title" content="Impressum | Social Media Recruiting Agentur" />
      </Helmet>
      
      <Navbar rootClassName="navbarroot-class-name"></Navbar>
      
      <section className="legal-hero-section">
        <div className="legal-hero">
          <div className="legal-hero-content">
            <h1 className="legal-heading">
              Impressum
            </h1>
            <p className="legal-subtitle">
              Angaben gemäß § 5 DDG
            </p>
          </div>
        </div>
      </section>

      <section className="legal-content-section">
        <div className="legal-content-wrapper">
          <div className="legal-content">
            
            <h2>Anbieter</h2>
            <div className="legal-info-box">
              <p>
                <strong>track by track GmbH</strong><br />
                Schliemannstr. 23<br />
                10437 Berlin
              </p>
            </div>

            <h2>Vertreten durch</h2>
            <p>
              <a href="https://www.linkedin.com/in/tobias-s-32bab365/" target="_blank" rel="noopener noreferrer">Tobias Sander</a>
            </p>

            <hr />

            <h2>Kontakt</h2>
            <p>
              <strong>Telefon:</strong> 030 403 665 430<br />
              <strong>Telefax:</strong> 030 403 665 450<br />
              <strong>E-Mail:</strong> <a href="mailto:info@social-media-recruiting-agentur.com">info@social-media-recruiting-agentur.com</a>
            </p>
            <p>
              <strong>DUNS-Nummer:</strong> 34-024-8055
            </p>

            <hr />

            <h2>Registereintrag</h2>
            <p>
              Eintragung im Handelsregister.<br />
              <strong>Registergericht:</strong> Amtsgericht Berlin-Charlottenburg<br />
              <strong>Registernummer:</strong> HRB 129805 B
            </p>

            <hr />

            <h2>Umsatzsteuer</h2>
            <p>
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
              <strong>DE814954842</strong>
            </p>

            <hr />

            <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p>
              Tobias Sander<br />
              Schliemannstr. 23<br />
              10437 Berlin
            </p>

            <hr />

            <h2>Streitschlichtung</h2>
            <p>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>

            <hr />

            <h2>Weitere rechtliche Informationen</h2>
            <p>
              Hier finden Sie unsere weiteren rechtlichen Dokumente:
            </p>
            <ul>
              <li><Link to="/agb">Allgemeine Geschäftsbedingungen (AGB)</Link></li>
              <li><Link to="/datenschutz">Datenschutzerklärung</Link></li>
              <li><Link to="/disclaimer">Disclaimer / Haftungsausschluss</Link></li>
            </ul>

          </div>
        </div>
      </section>

      <Footer activePage="impressum" />
    </div>
  )
}

export default Impressum
